import { render, staticRenderFns } from "./ButtonFrameless.vue?vue&type=template&id=a8ffff9a&"
import script from "./ButtonFrameless.vue?vue&type=script&lang=js&"
export * from "./ButtonFrameless.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports